import { render, staticRenderFns } from "./ChecklistTable.vue?vue&type=template&id=136c90fa"
import script from "./ChecklistTable.vue?vue&type=script&lang=js"
export * from "./ChecklistTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports